import { mapLanguageToProps } from 'i18n'
import da from 'admin/i18n/da'
import en from 'admin/i18n/en'
import fi from 'admin/i18n/fi'
import no from 'admin/i18n/no'
import se from 'admin/i18n/se'
import de from 'admin/i18n/de'
import it from 'admin/i18n/it'
import es from 'admin/i18n/es'
import ru from 'admin/i18n/ru'
import ja from 'admin/i18n/ja'
import { MapStateToProps } from 'react-redux'

export const languages = { da, de, en, fi, no, se, it, es, ru, ja }

export type Language = keyof typeof languages

export function mapLanguageToComponentProps<
  TStateProps = Record<string, never>,
  TOwnProps = Record<string, never>,
  State = Record<string, never>
>(map?: MapStateToProps<TStateProps, TOwnProps, State>) {
  return mapLanguageToProps(languages, 'component', map)
}

export function mapLanguageToPageProps<
  TStateProps = Record<string, never>,
  TOwnProps = Record<string, never>,
  State = Record<string, never>
>(map?: MapStateToProps<TStateProps, TOwnProps, State>) {
  return mapLanguageToProps(languages, 'page', map)
}

export function signatureLanguage(lang: Language) {
  return languages[lang in languages ? lang : 'en'].component
    .modalApplicationMessage.signature
}
